import { render } from "./S95809.vue?vue&type=template&id=326bf67d"
const script = {}
script.render = render

export default script